<div class="inspection-category width-100p">
  <div class="inspection-category-header flex-start-center pointer"
    [ngClass]="{'b-bottom': isExpanded, 'mb-23-pb-20':screenWidth < 520}" (click)="toggleIsExpanded()">
    <span class="fal font-gray-45 p-6" [ngClass]="{'fa-chevron-down': !isExpanded, 'fa-chevron-up': isExpanded}"></span>
    <span class="flex-start-center max-26">
      <p class="font-bold m-0 ml-2 text-truncate max-width-68" tooltipPosition="top" [pTooltip]="category?.title">
        {{category?.title}}</p>
      <div class="h-line ml-1 mr-1"></div>
      <p class="m-0 font-4c">
        {{category?.inspectionItems?.length}} item{{category?.length > 1? 's': ''}}
      </p>
    </span>

    <span *ngIf="screenWidth > 520" class="inspection-checklits-status" [innerHTML]="showStatusCheck()">
    </span>
  </div>

  <span *ngIf="screenWidth < 520" [innerHTML]="showStatusCheck()" class="inspection-checklits-status">
  </span>

  <div class="inspection-category-body" *ngIf="isExpanded">
    <div *ngFor="let inspectionItem of category?.inspectionItems" class="inspection-cat-item-wrapper">
      <app-inspection-category-item [workStatus]="workStatus" [isArchived]="isArchived" [isFinalized]="isFinalized"
        [inspectionItem]="inspectionItem" [screenWidth]="screenWidth"></app-inspection-category-item>
    </div>
  </div>
</div>